<div class="container"
  fxLayout="column">
  <div class="content">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>